export const REPLACE_URLS: Record<string, string> = {
  '/actions/': '/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دهم/': '/',
  '/author/bahar-saeidi/': '/',
  '/author/farhang/': '/',
  '/author/mahdi-yari/': '/',
  '/author/mina-hamedani/': '/',
  '/campaign/تیزهوشان/': '/',
  '/comments/': '/',
  '/comments/feed/': '/',
  '/feed/': '/',
  '/playlists/': '/',
  '/rss/': '/',
  '/user/action/watch/': '/',
  '/app/categories/': '/app/',
  '/app/embed/07uwbi9ou/': '/app/',
  '/app/embed/1dfpwsti0/': '/app/',
  '/app/embed/3ifb0yybe/': '/app/',
  '/app/embed/3pw4msvxt/': '/app/',
  '/app/embed/6ab8lwd1b/': '/app/',
  '/app/embed/7nl9tw0wz/': '/app/',
  '/app/embed/86p3vfojm/': '/app/',
  '/app/embed/9l1jf52fo/': '/app/',
  '/app/embed/amyxusni6/': '/app/',
  '/app/embed/bha0ktiqh/': '/app/',
  '/app/embed/bjloyj9d8/': '/app/',
  '/app/embed/dmbsjownp/': '/app/',
  '/app/embed/du7hitzkm/': '/app/',
  '/app/embed/ehvlhafvl/': '/app/',
  '/app/embed/fm2vrz3iz/': '/app/',
  '/app/embed/gkftfus3r/': '/app/',
  '/app/embed/groxut2gz/': '/app/',
  '/app/embed/hxvfmykrs/': '/app/',
  '/app/embed/ihzhfwqlf/': '/app/',
  '/app/embed/ii1nc1gor/': '/app/',
  '/app/embed/jl96cams4/': '/app/',
  '/app/embed/jumwlej72/': '/app/',
  '/app/embed/ogtppl7gv/': '/app/',
  '/app/embed/rvbmo6ima/': '/app/',
  '/app/embed/sicg3akeq/': '/app/',
  '/app/embed/smgicxnku/': '/app/',
  '/app/embed/tq4zbjk24/': '/app/',
  '/app/embed/uli3fyaay/': '/app/',
  '/app/embed/vwcisvhsr/': '/app/',
  '/app/embed/wxgborkuq/': '/app/',
  '/app/embed/xobfwjjbz/': '/app/',
  '/app/embed/yiep6zxga/': '/app/',
  '/app/embed/yij6dmkgo/': '/app/',
  '/app/embed/zn1qjwvft/': '/app/',
  '/app/featured/': '/app/',
  '/app/latest/': '/app/',
  '/app/learning/[slug]/': '/app/',
  '/app/learning/[slug]/[sectionSlug]/': '/app/',
  '/app/learning/grade/شیمی-یازدهم/': '/app/',
  '/app/learning/grade/فلسفه-دوازدهم/': '/app/',
  '/app/learning/grade/فیزیک-یازدهم/': '/app/',
  '/app/liked/': '/app/',
  '/app/live/': '/app/',
  '/app/media/': '/app/',
  '/app/members/': '/app/',
  '/app/recommended/': '/app/',
  '/app/search/': '/app/',
  '/app/tags/': '/app/',
  '/app/upload/': '/app/',
  '/app/user/': '/app/',
  '/app/user/about/': '/app/',
  '/app/user/playlists/': '/app/',
  '/app/users/otp-request/': '/app/',
  '/app/learning/ابتدایی-پایه-اول/آموزش-قرآن-اول-1/': '/app/learning/ابتدایی-پایه-اول/',
  '/app/learning/ابتدایی-پایه-اول/نگارش-فارسی-اول-3/': '/app/learning/ابتدایی-پایه-اول/',
  '/app/learning/ابتدایی-پایه-اول/ریاضی-اول/_/': '/app/learning/ابتدایی-پایه-اول/ریاضی-اول/',
  '/app/learning/ابتدایی-پایه-اول/ریاضی-اول-4/': '/app/learning/ابتدایی-پایه-اول/ریاضی-اول/',
  '/app/learning/ابتدایی-پایه-اول/علوم-تجربی-اول-5/': '/app/learning/ابتدایی-پایه-اول/علوم-تجربی-اول/',
  '/app/learning/ابتدایی-پایه-اول/فارسی-اول-2/': '/app/learning/ابتدایی-پایه-اول/فارسی-اول/',
  '/app/learning/ابتدایی-پایه-پنجم/آموزش-قرآن-پنجم-26/': '/app/learning/ابتدایی-پایه-پنجم/',
  '/app/learning/ابتدایی-پایه-پنجم/مطالعات-اجتماعی-پنجم-32/': '/app/learning/ابتدایی-پایه-پنجم/',
  '/app/learning/ابتدایی-پایه-پنجم/هدیه-های-آسمان-پنجم-27/': '/app/learning/ابتدایی-پایه-پنجم/',
  '/app/learning/ابتدایی-پایه-پنجم/ریاضی-پنجم-30/': '/app/learning/ابتدایی-پایه-پنجم/ریاضی-پنجم/',
  '/app/learning/ابتدایی-پایه-پنجم/علوم-تجربی-پنجم-31/': '/app/learning/ابتدایی-پایه-پنجم/علوم-تجربی-پنجم/',
  '/app/learning/ابتدایی-پایه-پنجم/فارسی-پنجم-28/': '/app/learning/ابتدایی-پایه-پنجم/فارسی-پنجم/',
  '/app/learning/ابتدایی-پایه-چهارم/مطالعات-اجتماعی-چهارم-25/': '/app/learning/ابتدایی-پایه-چهارم/',
  '/app/learning/ابتدایی-پایه-چهارم/نگارش-فارسی-چهارم-22/': '/app/learning/ابتدایی-پایه-چهارم/',
  '/app/learning/ابتدایی-پایه-چهارم/هدیه-های-آسمان-چهارم-20/': '/app/learning/ابتدایی-پایه-چهارم/',
  '/app/learning/ابتدایی-پایه-چهارم/علوم-تجربی-چهارم-24/': '/app/learning/ابتدایی-پایه-چهارم/علوم-تجربی-چهارم/',
  '/app/learning/ابتدایی-پایه-چهارم/فارسی-چهارم-21/': '/app/learning/ابتدایی-پایه-چهارم/فارسی-چهارم/',
  '/app/learning/ابتدایی-پایه-دوم/آموزش-قرآن-دوم-6/': '/app/learning/ابتدایی-پایه-دوم/',
  '/app/learning/ابتدایی-پایه-دوم/نگارش-فارسی-دوم-9/': '/app/learning/ابتدایی-پایه-دوم/',
  '/app/learning/ابتدایی-پایه-دوم/هدیه-های-آسمان-دوم-7/': '/app/learning/ابتدایی-پایه-دوم/',
  '/app/learning/ابتدایی-پایه-دوم/ریاضی-دوم-10/': '/app/learning/ابتدایی-پایه-دوم/ریاضی-دوم/',
  '/app/learning/ابتدایی-پایه-دوم/علوم-تجربی-دوم-11/': '/app/learning/ابتدایی-پایه-دوم/علوم-تجربی-دوم/',
  '/app/learning/ابتدایی-پایه-دوم/فارسی-دوم-8/': '/app/learning/ابتدایی-پایه-دوم/فارسی-دوم/',
  '/app/learning/ابتدایی-پایه-سوم/مطالعات-اجتماعی-سوم-18/': '/app/learning/ابتدایی-پایه-سوم/',
  '/app/learning/ابتدایی-پایه-سوم/نگارش-فارسی-سوم-15/': '/app/learning/ابتدایی-پایه-سوم/',
  '/app/learning/ابتدایی-پایه-سوم/هدیه-های-آسمان-سوم-13/': '/app/learning/ابتدایی-پایه-سوم/',
  '/app/learning/ابتدایی-پایه-سوم/علوم-تجربی-سوم-17/': '/app/learning/ابتدایی-پایه-سوم/علوم-تجربی-سوم/',
  '/app/learning/ابتدایی-پایه-سوم/فارسی-سوم-14/': '/app/learning/ابتدایی-پایه-سوم/فارسی-سوم/',
  '/app/learning/ابتدایی-پایه-ششم/آموزش-قرآن-ششم-33/': '/app/learning/ابتدایی-پایه-ششم/',
  '/app/learning/ابتدایی-پایه-ششم/مطالعات-اجتماعی-ششم-39/': '/app/learning/ابتدایی-پایه-ششم/',
  '/app/learning/ابتدایی-پایه-ششم/نگارش-فارسی-ششم-36/': '/app/learning/ابتدایی-پایه-ششم/',
  '/app/learning/ابتدایی-پایه-ششم/هدیه-های-آسمان-ششم-34/': '/app/learning/ابتدایی-پایه-ششم/',
  '/app/learning/ابتدایی-پایه-ششم/علوم-تجربی-ششم-38/': '/app/learning/ابتدایی-پایه-ششم/علوم-تجربی-ششم/',
  '/app/learning/ابتدایی-پایه-ششم/فارسی-ششم-35/': '/app/learning/ابتدایی-پایه-ششم/فارسی-ششم/',
  '/app/learning/متوسطه-اول-پایه-نهم/زیست-تیزهوشان-نهم/': '/app/learning/تیزهوشان-پایه-نهم/زیست-تیزهوشان-نهم/',
  '/app/learning/متوسطه-اول-پایه-نهم/فارسی-تیزهوشان-نهم/': '/app/learning/تیزهوشان-پایه-نهم/فارسی-تیزهوشان-نهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دهم-ریاضی-فیزیک/': '/app/learning/کنکور-پایه-دهم-ریاضی-فیزیک/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دهم-ریاضی-فیزیک/انگلیسی-دهم-91/': '/app/learning/کنکور-پایه-دهم-ریاضی-فیزیک/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دهم-ریاضی-فیزیک/ریاضی-دهم-84/': '/app/learning/کنکور-پایه-دهم-ریاضی-فیزیک/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دهم-ریاضی-فیزیک/عربی،زبان-قرآن-دهم-87/': '/app/learning/کنکور-پایه-دهم-ریاضی-فیزیک/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دهم-ریاضی-فیزیک/فارسی-دهم-81/': '/app/learning/کنکور-پایه-دهم-ریاضی-فیزیک/',
  '/app/learning/متوسطه-دوم-پایه-دوازدهم-علوم-انسانی/نگارش-دوازدهم/': '/app/learning/کنکور-پایه-دهم-ریاضی-فیزیک/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دهم-ریاضی-فیزیک/انگلیسی-دهم/': '/app/learning/کنکور-پایه-دهم-ریاضی-فیزیک/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دهم-ریاضی-فیزیک/دین-و-زندگی-دهم/': '/app/learning/کنکور-پایه-دهم-ریاضی-فیزیک/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دهم-ریاضی-فیزیک/ریاضی-دهم/': '/app/learning/کنکور-پایه-دهم-ریاضی-فیزیک/ریاضی-دهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دهم-ریاضی-فیزیک/شیمی-دهم/': '/app/learning/کنکور-پایه-دهم-ریاضی-فیزیک/شیمی-دهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دهم-ریاضی-فیزیک/شیمی-دهم-88/': '/app/learning/کنکور-پایه-دهم-ریاضی-فیزیک/شیمی-دهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دهم-ریاضی-فیزیک/فیزیک-دهم-83/': '/app/learning/کنکور-پایه-دهم-ریاضی-فیزیک/فیزیک-دهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دهم-ریاضی-فیزیک/هندسه-دهم/': '/app/learning/کنکور-پایه-دهم-ریاضی-فیزیک/هندسه-دهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دهم-ریاضی-فیزیک/هندسه-دهم-89/': '/app/learning/کنکور-پایه-دهم-ریاضی-فیزیک/هندسه-دهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دهم-علوم-انسانی/': '/app/learning/کنکور-پایه-دهم-علوم-انسانی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دهم-علوم-انسانی/انگلیسی-دهم-110/': '/app/learning/کنکور-پایه-دهم-علوم-انسانی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دهم-علوم-انسانی/جغرافیای-ایران-دهم-114/': '/app/learning/کنکور-پایه-دهم-علوم-انسانی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دهم-علوم-انسانی/دین-و-زندگی-دهم-112/': '/app/learning/کنکور-پایه-دهم-علوم-انسانی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دهم-علوم-انسانی/انگلیسی-دهم/': '/app/learning/کنکور-پایه-دهم-علوم-انسانی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دهم-علوم-انسانی/دین-و-زندگی-دهم/': '/app/learning/کنکور-پایه-دهم-علوم-انسانی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دهم-علوم-انسانی/فارسی-دهم/': '/app/learning/کنکور-پایه-دهم-علوم-انسانی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دهم-علوم-انسانی/اقتصاد-دهم/': '/app/learning/کنکور-پایه-دهم-علوم-انسانی/اقتصاد-دهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دهم-علوم-انسانی/تاریخ-دهم/': '/app/learning/کنکور-پایه-دهم-علوم-انسانی/تاریخ-دهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دهم-علوم-انسانی/تاریخ-دهم-107/':
    '/app/learning/کنکور-پایه-دهم-علوم-انسانی/تاریخ-دهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دهم-علوم-انسانی/ریاضی-و-آمار-دهم-113/':
    '/app/learning/کنکور-پایه-دهم-علوم-انسانی/ریاضی-و-آمار-دهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دهم-علوم-انسانی/عربی،زبان-قرآن-دهم/':
    '/app/learning/کنکور-پایه-دهم-علوم-انسانی/عربی،زبان-قرآن-دهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دهم-علوم-انسانی/عربی،زبان-قرآن-دهم-106/':
    '/app/learning/کنکور-پایه-دهم-علوم-انسانی/عربی،زبان-قرآن-دهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دهم-علوم-انسانی/علوم-وفنون-ادبی-دهم-105/':
    '/app/learning/کنکور-پایه-دهم-علوم-انسانی/علوم-وفنون-ادبی-دهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دهم-علوم-انسانی/منطق-دهم-109/': '/app/learning/کنکور-پایه-دهم-علوم-انسانی/منطق-دهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دهم-علوم-تجربی/دین-و-زندگی-دهم-128/': '/app/learning/کنکور-پایه-دهم-علوم-تجربی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دهم-علوم-تجربی/انگلیسی-دهم/': '/app/learning/کنکور-پایه-دهم-علوم-تجربی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دهم-علوم-تجربی/دین-و-زندگی-دهم/': '/app/learning/کنکور-پایه-دهم-علوم-تجربی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دهم-علوم-تجربی/عربی،زبان-قرآن-دهم/': '/app/learning/کنکور-پایه-دهم-علوم-تجربی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دهم-علوم-تجربی/فارسی-دهم/': '/app/learning/کنکور-پایه-دهم-علوم-تجربی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دهم-علوم-تجربی/ریاضی-دهم/': '/app/learning/کنکور-پایه-دهم-علوم-تجربی/ریاضی-دهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دهم-علوم-تجربی/ریاضی-دهم-135/': '/app/learning/کنکور-پایه-دهم-علوم-تجربی/ریاضی-دهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دهم-علوم-تجربی/زیست-شناسی-دهم/':
    '/app/learning/کنکور-پایه-دهم-علوم-تجربی/زیست-شناسی-دهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دهم-علوم-تجربی/زیست-شناسی-دهم-131/':
    '/app/learning/کنکور-پایه-دهم-علوم-تجربی/زیست-شناسی-دهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دهم-علوم-تجربی/شیمی-دهم-129/': '/app/learning/کنکور-پایه-دهم-علوم-تجربی/شیمی-دهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دهم-علوم-تجربی/فیزیک-دهم-130/': '/app/learning/کنکور-پایه-دهم-علوم-تجربی/فیزیک-دهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-ریاضی-فیزیک/دین-و-زندگی-دوازدهم/':
    '/app/learning/کنکور-پایه-دوازدهم-ریاضی-فیزیک/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-ریاضی-فیزیک/عربی،زبان-قرآن-دوازدهم-234/':
    '/app/learning/کنکور-پایه-دوازدهم-ریاضی-فیزیک/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-ریاضی-فیزیک/فارسی-دوازدهم-228/':
    '/app/learning/کنکور-پایه-دوازدهم-ریاضی-فیزیک/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-ریاضی-فیزیک/دین-و-زندگی-دوازدهم-229/':
    '/app/learning/کنکور-پایه-دوازدهم-ریاضی-فیزیک/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-ریاضی-فیزیک/عربی،زبان-قرآن-دوازدهم/':
    '/app/learning/کنکور-پایه-دوازدهم-ریاضی-فیزیک/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-ریاضی-فیزیک/فارسی-دوازدهم/': '/app/learning/کنکور-پایه-دوازدهم-ریاضی-فیزیک/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-ریاضی-فیزیک/حسابان-دوازدهم-236/':
    '/app/learning/کنکور-پایه-دوازدهم-ریاضی-فیزیک/حسابان-دوازدهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-ریاضی-فیزیک/حسابان-دوازدهم/':
    '/app/learning/کنکور-پایه-دوازدهم-ریاضی-فیزیک/حسابان-دوازدهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-ریاضی-فیزیک/ریاضیات-گسسته-دوازدهم-232/':
    '/app/learning/کنکور-پایه-دوازدهم-ریاضی-فیزیک/ریاضیات-گسسته-دوازدهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-ریاضی-فیزیک/شیمی-دوازدهم-235/':
    '/app/learning/کنکور-پایه-دوازدهم-ریاضی-فیزیک/شیمی-دوازدهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-ریاضی-فیزیک/فیزیک-دوازدهم-230/':
    '/app/learning/کنکور-پایه-دوازدهم-ریاضی-فیزیک/فیزیک-دوازدهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-ریاضی-فیزیک/هندسه-دوازدهم/':
    '/app/learning/کنکور-پایه-دوازدهم-ریاضی-فیزیک/هندسه-دوازدهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-ریاضی-فیزیک/هندسه-دوازدهم-231/':
    '/app/learning/کنکور-پایه-دوازدهم-ریاضی-فیزیک/هندسه-دوازدهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-علوم-انسانی/': '/app/learning/کنکور-پایه-دوازدهم-علوم-انسانی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-علوم-انسانی/انگلیسی-دوازدهم-255/':
    '/app/learning/کنکور-پایه-دوازدهم-علوم-انسانی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-علوم-انسانی/دین-و-زندگی-دوازدهم-257/':
    '/app/learning/کنکور-پایه-دوازدهم-علوم-انسانی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-علوم-انسانی/عربی،زبان-قرآن-دوازدهم-251/':
    '/app/learning/کنکور-پایه-دوازدهم-علوم-انسانی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-علوم-انسانی/انگلیسی-دوازدهم/':
    '/app/learning/کنکور-پایه-دوازدهم-علوم-انسانی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-علوم-انسانی/جغرافیا-دوازدهم/':
    '/app/learning/کنکور-پایه-دوازدهم-علوم-انسانی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-علوم-انسانی/دین-و-زندگی-دوازدهم/':
    '/app/learning/کنکور-پایه-دوازدهم-علوم-انسانی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-علوم-انسانی/فارسی-دوازدهم/': '/app/learning/کنکور-پایه-دوازدهم-علوم-انسانی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-علوم-انسانی/تاریخ-دوازدهم/':
    '/app/learning/کنکور-پایه-دوازدهم-علوم-انسانی/تاریخ-دوازدهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-علوم-انسانی/تاریخ-دوازدهم-259/':
    '/app/learning/کنکور-پایه-دوازدهم-علوم-انسانی/تاریخ-دوازدهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-علوم-انسانی/جامعه-شناسی-دوازدهم/':
    '/app/learning/کنکور-پایه-دوازدهم-علوم-انسانی/جامعه-شناسی-دوازدهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-علوم-انسانی/جامعه-شناسی-دوازدهم-253/':
    '/app/learning/کنکور-پایه-دوازدهم-علوم-انسانی/جامعه-شناسی-دوازدهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-علوم-انسانی/عربی،زبان-قرآن-دوازدهم/':
    '/app/learning/کنکور-پایه-دوازدهم-علوم-انسانی/عربی،زبان-قرآن-دوازدهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-علوم-انسانی/علوم-وفنون-ادبی-دوازدهم/':
    '/app/learning/کنکور-پایه-دوازدهم-علوم-انسانی/علوم-وفنون-ادبی-دوازدهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-علوم-انسانی/علوم-وفنون-ادبی-دوازدهم-250/':
    '/app/learning/کنکور-پایه-دوازدهم-علوم-انسانی/علوم-وفنون-ادبی-دوازدهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-علوم-انسانی/فلسفه-دوازدهم/':
    '/app/learning/کنکور-پایه-دوازدهم-علوم-انسانی/فلسفه-دوازدهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-علوم-تجربی/': '/app/learning/کنکور-پایه-دوازدهم-علوم-تجربی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-علوم-تجربی/انگلیسی-دوازدهم-277/':
    '/app/learning/کنکور-پایه-دوازدهم-علوم-تجربی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-علوم-تجربی/دین-و-زندگی-دوازدهم-270/':
    '/app/learning/کنکور-پایه-دوازدهم-علوم-تجربی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-علوم-تجربی/عربی،زبان-قرآن-دوازدهم-275/':
    '/app/learning/کنکور-پایه-دوازدهم-علوم-تجربی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-علوم-تجربی/فارسی-دوازدهم-269/':
    '/app/learning/کنکور-پایه-دوازدهم-علوم-تجربی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-علوم-تجربی/انگلیسی-دوازدهم/': '/app/learning/کنکور-پایه-دوازدهم-علوم-تجربی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-علوم-تجربی/دین-و-زندگی-دوازدهم/':
    '/app/learning/کنکور-پایه-دوازدهم-علوم-تجربی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-علوم-تجربی/عربی،زبان-قرآن-دوازدهم/':
    '/app/learning/کنکور-پایه-دوازدهم-علوم-تجربی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-علوم-تجربی/فارسی-دوازدهم/': '/app/learning/کنکور-پایه-دوازدهم-علوم-تجربی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-علوم-تجربی/ریاضی-دوازدهم/':
    '/app/learning/کنکور-پایه-دوازدهم-علوم-تجربی/ریاضی-دوازدهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-علوم-تجربی/ریاضی-دوازدهم-276/':
    '/app/learning/کنکور-پایه-دوازدهم-علوم-تجربی/ریاضی-دوازدهم/',
  '/app/learning/کنکور-پایه-دوازدهم-علوم-تجربی/زیست-شناسی-دوازدهم-/':
    '/app/learning/کنکور-پایه-دوازدهم-علوم-تجربی/زیست-شناسی-دوازدهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-علوم-تجربی/زیست-شناسی-دوازدهم/':
    '/app/learning/کنکور-پایه-دوازدهم-علوم-تجربی/زیست-شناسی-دوازدهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-علوم-تجربی/شیمی-دوازدهم/':
    '/app/learning/کنکور-پایه-دوازدهم-علوم-تجربی/شیمی-دوازدهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-علوم-تجربی/فیزیک-دوازدهم/':
    '/app/learning/کنکور-پایه-دوازدهم-علوم-تجربی/فیزیک-دوازدهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-دوازدهم-علوم-تجربی/فیزیک-دوازدهم-273/':
    '/app/learning/کنکور-پایه-یازدهم-ریاضی-فیزیک/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-ریاضی-فیزیک/': '/app/learning/کنکور-پایه-یازدهم-ریاضی-فیزیک/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-ریاضی-فیزیک/انگلیسی-یازدهم-164/':
    '/app/learning/کنکور-پایه-یازدهم-ریاضی-فیزیک/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-ریاضی-فیزیک/دین-و-زندگی-یازدهم-159/':
    '/app/learning/کنکور-پایه-یازدهم-ریاضی-فیزیک/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-ریاضی-فیزیک/انگلیسی-یازدهم/': '/app/learning/کنکور-پایه-یازدهم-ریاضی-فیزیک/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-ریاضی-فیزیک/دین-و-زندگی-یازدهم/':
    '/app/learning/کنکور-پایه-یازدهم-ریاضی-فیزیک/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-ریاضی-فیزیک/عربی،زبان-قرآن-یازدهم/':
    '/app/learning/کنکور-پایه-یازدهم-ریاضی-فیزیک/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-ریاضی-فیزیک/فارسی-یازدهم/': '/app/learning/کنکور-پایه-یازدهم-ریاضی-فیزیک/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-ریاضی-فیزیک/آمار-و-احتمال-یازدهم/':
    '/app/learning/کنکور-پایه-یازدهم-ریاضی-فیزیک/آمار-و-احتمال-یازدهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-ریاضی-فیزیک/حسابان-یازدهم/':
    '/app/learning/کنکور-پایه-یازدهم-ریاضی-فیزیک/حسابان-یازدهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-ریاضی-فیزیک/حسابان-یازدهم-156/':
    '/app/learning/کنکور-پایه-یازدهم-ریاضی-فیزیک/حسابان-یازدهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-ریاضی-فیزیک/شیمی-یازدهم/':
    '/app/learning/کنکور-پایه-یازدهم-ریاضی-فیزیک/شیمی-یازدهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-ریاضی-فیزیک/فیزیک-یازدهم/':
    '/app/learning/کنکور-پایه-یازدهم-ریاضی-فیزیک/فیزیک-یازدهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-ریاضی-فیزیک/فیزیک-یازدهم-160/':
    '/app/learning/کنکور-پایه-یازدهم-ریاضی-فیزیک/فیزیک-یازدهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-علوم-انسانی/انگلیسی-یازدهم-191/':
    '/app/learning/کنکور-پایه-یازدهم-علوم-انسانی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-علوم-انسانی/جغرافیا-یازدهم-188/':
    '/app/learning/کنکور-پایه-یازدهم-علوم-انسانی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-علوم-انسانی/دین-و-زندگی-یازدهم-181/':
    '/app/learning/کنکور-پایه-یازدهم-علوم-انسانی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-علوم-انسانی/انگلیسی-یازدهم/': '/app/learning/کنکور-پایه-یازدهم-علوم-انسانی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-علوم-انسانی/جغرافیا-یازدهم/': '/app/learning/کنکور-پایه-یازدهم-علوم-انسانی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-علوم-انسانی/دین-و-زندگی-یازدهم/':
    '/app/learning/کنکور-پایه-یازدهم-علوم-انسانی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-علوم-انسانی/فارسی-یازدهم-185/': '/app/learning/کنکور-پایه-یازدهم-علوم-انسانی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-علوم-انسانی/تاریخ-یازدهم-183/':
    '/app/learning/کنکور-پایه-یازدهم-علوم-انسانی/تاریخ-یازدهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-علوم-انسانی/جامعه-شناسی-یازدهم-189/':
    '/app/learning/کنکور-پایه-یازدهم-علوم-انسانی/جامعه-شناسی-یازدهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-علوم-انسانی/روان-شناسی-یازدهم/':
    '/app/learning/کنکور-پایه-یازدهم-علوم-انسانی/روان-شناسی-یازدهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-علوم-انسانی/روان-شناسی-یازدهم-184/':
    '/app/learning/کنکور-پایه-یازدهم-علوم-انسانی/روان-شناسی-یازدهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-علوم-انسانی/ریاضی-و-آمار-یازدهم/':
    '/app/learning/کنکور-پایه-یازدهم-علوم-انسانی/ریاضی-و-آمار-یازدهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-علوم-انسانی/عربی،زبان-قرآن-یازدهم/':
    '/app/learning/کنکور-پایه-یازدهم-علوم-انسانی/عربی،زبان-قرآن-یازدهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-علوم-انسانی/عربی،زبان-قرآن-یازدهم-187/':
    '/app/learning/کنکور-پایه-یازدهم-علوم-انسانی/عربی،زبان-قرآن-یازدهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-علوم-انسانی/علوم-وفنون-ادبی-یازدهم/':
    '/app/learning/کنکور-پایه-یازدهم-علوم-انسانی/علوم-وفنون-ادبی-یازدهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-علوم-انسانی/علوم-وفنون-ادبی-یازدهم-186/':
    '/app/learning/کنکور-پایه-یازدهم-علوم-انسانی/علوم-وفنون-ادبی-یازدهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-علوم-انسانی/فلسفه-یازدهم-190/':
    '/app/learning/کنکور-پایه-یازدهم-علوم-انسانی/فلسفه-یازدهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-علوم-تجربی/': '/app/learning/کنکور-پایه-یازدهم-علوم-تجربی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-علوم-تجربی/انگلیسی-یازدهم-210/': '/app/learning/کنکور-پایه-یازدهم-علوم-تجربی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-علوم-تجربی/دین-و-زندگی-یازدهم-214/':
    '/app/learning/کنکور-پایه-یازدهم-علوم-تجربی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-علوم-تجربی/عربی،زبان-قرآن-یازدهم-207/':
    '/app/learning/کنکور-پایه-یازدهم-علوم-تجربی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-علوم-تجربی/فارسی-یازدهم-213/': '/app/learning/کنکور-پایه-یازدهم-علوم-تجربی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-علوم-تجربی/انگلیسی-یازدهم/': '/app/learning/کنکور-پایه-یازدهم-علوم-تجربی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-علوم-تجربی/دین-و-زندگی-یازدهم/': '/app/learning/کنکور-پایه-یازدهم-علوم-تجربی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-علوم-تجربی/عربی،زبان-قرآن-یازدهم/':
    '/app/learning/کنکور-پایه-یازدهم-علوم-تجربی/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-علوم-تجربی/ریاضی-یازدهم/':
    '/app/learning/کنکور-پایه-یازدهم-علوم-تجربی/ریاضی-یازدهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-علوم-تجربی/زیست-شناسی-یازدهم/':
    '/app/learning/کنکور-پایه-یازدهم-علوم-تجربی/زیست-شناسی-یازدهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-علوم-تجربی/زیست-شناسی-یازدهم-208/':
    '/app/learning/کنکور-پایه-یازدهم-علوم-تجربی/زیست-شناسی-یازدهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-علوم-تجربی/شیمی-یازدهم-215/':
    '/app/learning/کنکور-پایه-یازدهم-علوم-تجربی/شیمی-یازدهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-علوم-تجربی/فیزیک-یازدهم/':
    '/app/learning/کنکور-پایه-یازدهم-علوم-تجربی/فیزیک-یازدهم/',
  '/app/learning/متوسطه-دوم-پایه-کنکور-یازدهم-علوم-تجربی/فیزیک-یازدهم-212/':
    '/app/learning/کنکور-پایه-یازدهم-علوم-تجربی/فیزیک-یازدهم/',
  '/app/learning/متوسطه-اول-پایه-نهم/انگلیسی/': '/app/learning/متوسطه-اول-پایه-نهم/انگلیسی-نهم/',
  '/app/learning/متوسطه-اول-پایه-نهم/عربی/': '/app/learning/متوسطه-اول-پایه-نهم/عربی-نهم/',
  '/app/learning/متوسطه-اول-پایه-نهم/علوم-تجربی/': '/app/learning/متوسطه-اول-پایه-نهم/علوم-تجربی-نهم/',
  '/app/learning/متوسطه-اول-پایه-نهم/فارسی/': '/app/learning/متوسطه-اول-پایه-نهم/فارسی-نهم/',
  '/app/learning/متوسطه-اول-پایه-هشتم»/': '/app/learning/متوسطه-اول-پایه-هشتم/',
  '/app/learning/متوسطه-اول-پایه-هشتم/انگلیسی/': '/app/learning/متوسطه-اول-پایه-هشتم/انگلیسی-هشتم/',
  '/app/learning/متوسطه-اول-پایه-هشتم/پیام-های-آسمان/': '/app/learning/متوسطه-اول-پایه-هشتم/پیام-های-آسمان-هشتم/',
  '/app/learning/متوسطه-اول-پایه-هشتم/علوم-تجربی/': '/app/learning/متوسطه-اول-پایه-هشتم/علوم-تجربی-هشتم/',
  '/app/learning/متوسطه-اول-پایه-هشتم/فارسی/': '/app/learning/متوسطه-اول-پایه-هشتم/فارسی-هشتم/',
  '/app/learning/متوسطه-اول-پایه-هفتم/پیام-های-آسمان/': '/app/learning/متوسطه-اول-پایه-هفتم/پیام-های-آسمان-هفتم/',
  '/app/learning/متوسطه-اول-پایه-هفتم/ریاضی-هفتم-44/': '/app/learning/متوسطه-اول-پایه-هفتم/ریاضی-هفتم/',
  '/app/learning/متوسطه-اول-پایه-هفتم/علوم-تجربی/': '/app/learning/متوسطه-اول-پایه-هفتم/علوم-تجربی-هفتم/',
  '/app/learning/متوسطه-اول-پایه-هفتم/مطالعات-اجتماعی/': '/app/learning/متوسطه-اول-پایه-هفتم/مطالعات-اجتماعی-هفتم/',
  '/app/learning/متوسطه-دوم-پایه-دوازدهم-علوم-انسانی/نگارش-دوازدهم-245/':
    '/app/learning/متوسطه-دوم-پایه-دوازدهم-علوم-انسانی/',
  '/app/learning/متوسطه-دوم-پایه-دوازدهم-علوم-تجربی/فارسی-دوازدهم-260/':
    '/app/learning/متوسطه-دوم-پایه-دوازدهم-علوم-انسانی/فارسی-دوازدهم/',
  '/آرشیو-مقالات/': '/blog/',
  '/تماس-با-ما/': '/contact-us/',
  '/پرسش-های-متداول/': '/question/',
  '/teacher/آزاده-درخشان/feed/': '/teacher/',
  '/teacher/ثمین توفیقی/': '/teacher/',
  '/teacher/حمیدرضا-منصوریان/feed/': '/teacher/',
  '/teacher/رضا-ابراهیمی/feed/': '/teacher/',
  '/teacher/رضا-پورحسینی/feed/': '/teacher/',
  '/teacher/سید علی مرتضوی/': '/teacher/',
  '/teacher/سید-علی-عاملیان/feed/': '/teacher/',
  '/teacher/سید-محمد-میرباقری/feed/': '/teacher/',
  '/teacher/شهرام-شاه-پرویزی/feed/': '/teacher/',
  '/teacher/صادق-رزبان/feed/': '/teacher/',
  '/teacher/علیرضا-شیخ-عطار/feed/': '/teacher/',
  '/teacher/فرزاد-نامی/feed/': '/teacher/',
  '/teacher/محمد-تفقدی/feed/': '/teacher/',
  '/teacher/محمد-جواد-حیدری/feed/': '/teacher/',
  '/teacher/محمد-جواد-سه-دهی/feed/': '/teacher/',
  '/teacher/محمد-حسین-ملکوتی/feed/': '/teacher/',
  '/teacher/محمدرضا-میبدی/feed/': '/teacher/',
  '/teacher/محمد-صحت-کار/feed/': '/teacher/',
};
